export function filterRecipeByTags(recipe, filteredTagsId) {
  var showRecipe = true;
  var recipeTagsId = [];
  for (var j = 0; j < recipe.tags.length; j++) {
    var tag = recipe.tags[j];
    recipeTagsId.push(tag.id);
  }
  for (var _j = 0; _j < filteredTagsId.length; _j++) {
    var tagId = filteredTagsId[_j];
    if (recipeTagsId.indexOf(tagId) === -1) {
      showRecipe = false;
      break;
    }
  }
  return showRecipe;
}